export default __webpack_public_path__ + "static/media/teapot.c1042ca6.png";